// extracted by mini-css-extract-plugin
module.exports = {"waterWave":"index_waterWave-3uXDh","text":"index_text-3bI7Q","waterWaveCanvasWrapper":"index_waterWaveCanvasWrapper-3s4kB"};